/**
 * Gets a display name for a team member, falling back to the email
 * prefix (before @) if no name is set.
 */
export const getDisplayName = (member: {
  name: string
  email: string
}): string => {
  if (member.name && member.name.trim() !== '') {
    return member.name
  }
  // Fallback: use email prefix (before @) as display name
  if (member.email && member.email.includes('@')) {
    return member.email.split('@')[0]
  }
  return member.email || 'Unknown'
}
